import { Injectable } from '@angular/core';
import { NydusNetworkApiDataService } from '@rd/core/services/nydus-network-api-data/nydus-network-api-data.service';
import { RewardsProgramShowResponse } from '@rd/types/rewards-program.response';
import { RewardsProgramPreference } from '@rd/types/rewards_program.type';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class RewardsProgramApiService {
  constructor(private nydusNetworkApiService: NydusNetworkApiDataService) {}

  getRewardsProgramPreference(): Observable<RewardsProgramPreference> {
    return this.nydusNetworkApiService
      .get<RewardsProgramShowResponse>('rewards_program_preference')
      .pipe(
        map(({ data }) => {
          return {
            id: data.id,
            rewardsProgramId: data.relationships.rewardsProgram.data.id,
            userId: data.relationships.user.data.id,
          };
        }),
      );
  }

  createRewardsProgramPreference(
    rewardsProgramId: string,
  ): Observable<RewardsProgramPreference> {
    return this.nydusNetworkApiService
      .post<RewardsProgramShowResponse>('rewards_program_preference', {
        rewards_program_preference: {
          rewards_program_id: rewardsProgramId,
        },
      })
      .pipe(
        map(({ data }) => {
          return {
            id: data.id,
            rewardsProgramId: data.relationships.rewardsProgram.data.id,
            userId: data.relationships.user.data.id,
          };
        }),
      );
  }
}
